
import Vue from 'vue';
import VueJsonPretty from 'vue-json-pretty';
import { abstractField } from "vue-form-generator";

import 'vue-json-pretty/lib/styles.css';

export default {
  mixins: [ abstractField ],
  components: {
    VueJsonPretty,
  },
  mounted() {
    window.addEventListener("keydown", this.preventFormSubmitOnEnter);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.preventFormSubmitOnEnter);
  },
  methods: {
    preventFormSubmitOnEnter(e) {
      if (e.key === "Enter" && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
      }
    }
  }
}
